var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9228 0.654784C19.1625 0.510763 19.4487 0.464949 19.7215 0.526953C19.9943 0.588956 20.2324 0.753959 20.3859 0.987343L21.4572 2.61775C21.5971 2.83084 21.657 3.08644 21.6263 3.33935C21.5956 3.59227 21.4763 3.82621 21.2894 3.99981L21.2862 4.00413L21.271 4.01817L21.2094 4.07539L20.9659 4.30754C19.6186 5.61142 18.3123 6.95671 17.0486 8.34144C14.6712 10.9501 11.848 14.3642 9.94781 17.6768C9.41757 18.6011 8.12228 18.7998 7.35398 18.0018L0.336481 10.7266C0.235915 10.6223 0.157391 10.4989 0.105576 10.3637C0.0537612 10.2285 0.0297132 10.0843 0.0348615 9.93966C0.0400098 9.79502 0.0742493 9.65288 0.135545 9.52171C0.196841 9.39053 0.283941 9.27299 0.391669 9.17607L2.51261 7.2671C2.69899 7.09943 2.93799 7.0016 3.18869 6.99038C3.43939 6.97915 3.6862 7.05521 3.88689 7.20555L7.4676 9.88438C13.06 4.38096 16.2327 2.26899 18.9228 0.654784Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckicon);
export default __webpack_public_path__ + "static/media/CHECKICON.64084cfa1774843275ed314ca6aea712.svg";
export { ForwardRef as ReactComponent };